"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatTime = formatTime;
exports.formatDate = formatDate;
exports.capitalizeString = exports.numberWithCommas = exports.roundDecimal = exports.inPercent = exports.validateURL = exports.validateDate = exports.validatePct = exports.validateNumber = exports.validateString = void 0;

var _moment = _interopRequireDefault(require("moment"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * @desc Formats time in secs to hours, mins, secs
 * @param  {Number} secs The number of seconds to convert.
 * @return {String} Time in hours, mins, secs.
 */
function formatTime(secs) {
  if (secs === undefined) {
    return '0s';
  }

  var d = Math.floor(secs / (3600 * 24));
  secs -= d * 3600 * 24;
  var h = Math.floor(secs / 3600);
  secs -= h * 3600;
  var m = Math.floor(secs / 60);
  secs -= m * 60;
  var tmp = [];
  d && tmp.push("".concat(d, "d"));
  (d || h) && tmp.push("".concat(h, "h"));
  (d || h || m) && tmp.push("".concat(m, "m"));
  tmp.push("".concat(Math.floor(secs), "s"));
  return tmp.join(' ');
}

function formatDate(date) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (options["short"]) {
    return (0, _moment["default"])(date).utc(options.utc).format('MM/DD/YY');
  }

  return (0, _moment["default"])(date).utc(options.utc).format('Do MMMM YYYY');
}
/**
 * @desc Simple validation functions
 * @param {String} data
 * @return {Boolean}
 */


var validateString = function validateString(data) {
  return !!data && typeof data === 'string' && data.length > 0;
};
/**
 * @desc Simple validation functions
 * @param {Number} data
 * @return {Boolean}
 */


exports.validateString = validateString;

var validateNumber = function validateNumber(data) {
  return !isNaN(data) && typeof data === 'number';
};
/**
 * @desc Simple validation percentage number between 0 & 1
 * @param {Number} data
 * @return {Boolean}
 */


exports.validateNumber = validateNumber;

var validatePct = function validatePct(data) {
  return validateNumber(data) && data >= 0 && data <= 1;
};
/**
 * @desc vali-Date? Validate date string
 * @param {Date} data
 * @return {Boolean}
 */


exports.validatePct = validatePct;

var validateDate = function validateDate(data) {
  return !!data && !isNaN(Date.parse(data));
};
/**
 * @desc Check if a URL is relatively correct.
 * @param {Date} data
 * @return {Boolean}
 */


exports.validateDate = validateDate;

var validateURL = function validateURL(url) {
  return /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?.*$/.test(url);
};
/**
 * Return the percentual representation of a number.
 * @param  {Number} number        The number to convert.
 * @param  {Number} [decimals=1]  Maximum decimals to represent.
 * @return {String}               Given number in percentual + %.
 * @example
 * inPercent(0.1);
 * // Returns '10%'
 * inPercent(0.0001);
 * // Returns '0%'
 * inPercent(0.10001, 3);
 * // Returns '10.001%'
 */


exports.validateURL = validateURL;

var inPercent = function inPercent(number) {
  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var roundFactor = Math.pow(10, decimals);
  var roundedNumber = Math.round(number * roundFactor * 100) / roundFactor;
  return "".concat(roundedNumber, "%");
};

exports.inPercent = inPercent;

var roundDecimal = function roundDecimal(number) {
  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  if (typeof number !== 'number') {
    return null;
  }

  var roundFactor = Math.pow(10, decimals);
  return Math.round(number * roundFactor) / roundFactor;
}; // Format numbers with commas


exports.roundDecimal = roundDecimal;

var numberWithCommas = function numberWithCommas(number) {
  if (typeof number === 'number') {
    return roundDecimal(number).toLocaleString();
  }

  return null;
};
/**
 * @desc capitalize first letter of string
 */


exports.numberWithCommas = numberWithCommas;

var capitalizeString = function capitalizeString(str) {
  return str ? str.charAt(0).toUpperCase() + str.substr(1) : null;
};

exports.capitalizeString = capitalizeString;

//# sourceMappingURL=Utils.js.map